import { render, staticRenderFns } from "./PlanInformation.vue?vue&type=template&id=53894b90&"
import script from "./PlanInformation.vue?vue&type=script&lang=js&"
export * from "./PlanInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports